<section class="section-product-hero country-hero" *ngIf="_heroData">
  <div class="circle-gradient">&nbsp;</div>
  <div class="section-container">
    <div class="product-hero-content-box">
      <div>
        <span class="product-hero-subheading mar-b-16">
          {{ _heroData?.tagName }}
          <img src="{{ _heroData?.tagIcon }}" alt="{{ _heroData?.tagName }}" />
        </span>
        <h1 class="product-hero-header">
          {{ _heroData?.header }}
        </h1>
        <div
          class="landing-hero-content mar-t-24"
          [innerHtml]="_heroData?.paragraph | toHtml"
        ></div>
        <div class="landing-btn mar-t-48 align-c">
          <a
            href="{{ _heroData?.button1?.url | urlParams: queryParams }}"
            target="{{ _heroData?.button1?.target }}"
            class="btn btn-full"
            >{{ _heroData?.button1?.text }}</a
          >
          @if(_heroData?.button2?.text){
            <app-common-talktosales-button
              [text]="_heroData?.button2?.text"
            ></app-common-talktosales-button>
          }
        </div>
      </div>
      <div class="image-container">
        <img
          src="{{ _heroData?.image?.file?.url }}"
          alt="{{ _heroData?.image?.title }}"
        />
      </div>
    </div>
  </div>
</section>
